import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import { Staff } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { tryParseJSON } from "./util";

@Component({})
export default class PatientContact extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("fullName", userNamespace)
  fullName!: string;

  @Action("accessRequest", userNamespace)
  accessRequest!: Function;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("showStaff", patientNamespace)
  showStaff!: boolean;

  @Prop(Object)
  data!: Patient;

  sending = false;
  dialogOpen = false;
  staff: Staff | null = null;
  pageText: string = "";
  openPageDialog(staff: Staff) {
    this.dialogOpen = true;
    if (staff.autoFill) {
      this.pageText = staff.autoFill
        .replace(/\$\{user\}/g, this.fullName)
        .replace(/\$\{room\}/g, this.current.census.displayRoom);
    } else {
      this.pageText = "";
    }
    this.staff = staff;
  }

  sendPage() {
    if (this.pageText === "" || !this.staff) {
      return;
    }

    if (this.demo) {
      this.handleResponse(true);
      return;
    }

    this.sending = true;

    const pager = this.staff.pager;
    const prependText = this.staff.autoFill ? "" : `${this.fullName}: `;
    const message = encodeURIComponent(`${prependText}${this.pageText}`);

    this.accessRequest({
      data: {
        message,
        pager
      },
      params: {
        action: "page",
        area: this.area,
        roomSys: this.current.census.roomSys
      }
    }).then(
      () => {
        this.handleResponse(true);
      },
      () => {
        this.handleResponse(false);
      }
    );
  }

  handleResponse(success: boolean) {
    this.sending = false;
    if (success) {
      this.dialogOpen = false;
      this.pageText = "";
    }
  }

  closePopup() {
    this.dialogOpen = false;
  }

  get varPhones() {
    return tryParseJSON(this.vars.logicRules.RulePhone, []);
  }

  get minWidth() {
    return this.$vuetify.breakpoint.width < 800 ? "0px" : "800px";
  }
}
